import React from "react";
import styled from "@emotion/styled";
import SanitizeHtml from "@components/sanitize-html";

function LegalDocument(props: any) {
  const { document } = props;

  return (
    <Wrapper className="container">
      <SanitizeHtml html={document} />
    </Wrapper>
  );
}

export default LegalDocument;

const Wrapper = styled.div`
  margin-top: 150px;
  color: var(--color-brand-blue-main);
  text-align: justify;
  margin-bottom: 50px;
  h1 {
    text-align: left;
    margin-bottom: 10px;
    @media screen and (max-width: 767px) {
      font-size: 1.3rem;
    }
  }
  & p {
    margin-bottom: 15px;
  }

  & ol {
    padding-left: 40px;
    margin-bottom: 10px;
  }
`;
